import React from "react";
import { getCookieData, getUserIdTokenForIonTime } from "../../../helper/api";
import { ApproveRejectPayload } from "../../../model/timesheet";
import { ReportStatusEnum, USERROLEENUM } from "../../../helper/constant";
import { useReportTimesheetContext } from "../../../context/ReportTimsheetContex";
import StaticModal from "../../../components/staticModel";
import { useAuth } from "../../../context/LoginContext";

type reportProps = {
  report_id: number | null;
  daysRecord: Date[];
  checkapproved: boolean;
  showapproveReject?: boolean;
  modelClose?: () => void;
};

const ApproveRejectForm: React.FC<reportProps> = ({
  report_id,
  daysRecord,
  checkapproved = false,
  showapproveReject = false,
  modelClose,
}) => {
  const getUserId = getUserIdTokenForIonTime();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { user } = useAuth();
  const userRoleType = getCookieData("roleId")
    ? Number(getCookieData("roleId"))
    : user
    ? user.role_id
    : null;
  const [ApproveRejectButtonType, setApproveRejectButtonType] =
    React.useState<string>("");
  const { approve_reject_timesheet } = useReportTimesheetContext();
  const [rejectForm, setRejectForm] = React.useState<{
    remark: string;
    dates: number[];
  }>({
    remark: "",
    dates: [],
  });
  const [error, setError] = React.useState<string>("");
   const query = getCookieData("timesheetsReport");
 const cookeei = query ? JSON.parse(query) : null;
  const onSubmit = async (statusID: number) => {
    if (statusID === ReportStatusEnum.Approved) {
      const payload: ApproveRejectPayload = {
        status: statusID,
        user_id: Number(getUserId),
        report_id: Number(report_id),
        remarks: rejectForm.remark ?? "Approved",
        dates: daysRecord.map((date) => {
          return date.getDate();
        }),
      };
      await approve_reject_timesheet(payload);
      if(cookeei?.role === "admin"){
        modelClose ? modelClose() : window.close();
        // navigate(0);
      }
      return;
    }
    setError("");

    if (rejectForm.dates.length === 0) {
      setError("select the rejection dates");
      return;
    }
    if (!rejectForm.remark) {
      setError("remark is required");
      return;
    }
    if (report_id) {
      const payload = {
        status: statusID,
        user_id: Number(getUserId),
        report_id: Number(report_id),
        remarks: rejectForm.remark,
        dates: rejectForm.dates,
      };
      await approve_reject_timesheet(payload);
      return;
    }
  };

  const openModal = (type: string) => {
    setApproveRejectButtonType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setError("");
    setApproveRejectButtonType("");
    setIsModalOpen(false);
  };

  return (
    <>
      <StaticModal
        headerName={ApproveRejectButtonType}
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <div className="max-w-4xl grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ">
          {error && (
            <div className="text-sm mb-2 text-red-600 capitalize text-center">
              {error}
            </div>
          )}

          {ApproveRejectButtonType === "Reject Timesheet" && (
            <div className="mb-2 col-span-full">
              <label
                htmlFor="description"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Days <span className="text-red-400">*</span>
              </label>
              <div className="flex items-center ">
                {daysRecord.map((date, index) => (
                  <div
                    key={index}
                    className=" mx-4 mt-2 flex items-center capitalize"
                  >
                    <input
                      type="checkbox"
                      // readOnly={!checkapproved}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      checked={rejectForm.dates.includes(date.getDate())}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setRejectForm((prevForm) => {
                          let updatedDates;
                          if (isChecked) {
                            updatedDates = [...prevForm.dates, date.getDate()];
                          } else {
                            updatedDates = prevForm.dates.filter(
                              (day) => day !== date.getDate()
                            );
                          }
                          return { ...prevForm, dates: updatedDates };
                        });
                      }}
                    />
                    <label className="ms-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">
                      {date
                        .toLocaleDateString("en-US", { month: "short" })
                        .toLowerCase()}{" "}
                      {date.getDate()}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="mb-2 col-span-full">
            <label
              htmlFor="description"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              {ApproveRejectButtonType === "Reject Timesheet"
                ? "Remark"
                : "Comment"}{" "}
              {ApproveRejectButtonType === "Reject Timesheet" && (
                <span className="text-red-400">*</span>
              )}
            </label>

            <textarea
              value={rejectForm.remark}
              rows={4}
              minLength={0}
              // readOnly={!checkapproved}
              maxLength={100}
              onChange={(e) =>
                setRejectForm({ ...rejectForm, remark: e.target.value })
              }
              id="remark"
              className="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            />
          </div>

          <div className="col-span-full">
            {ApproveRejectButtonType === "Approve Timesheet" && (
              <button
                type="button"
                onClick={() => onSubmit(ReportStatusEnum.Approved)}
                className="text-white bg-blue-700 mr-2 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Submit
              </button>
            )}
            {ApproveRejectButtonType === "Reject Timesheet" && (
              <button
                type="button"
                onClick={() => onSubmit(ReportStatusEnum.Returnedforreview)}
                className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </StaticModal>
        <div className="col-span-full">
          {checkapproved && !showapproveReject && (
            <button
              type="button"
              onClick={() => openModal("Approve Timesheet")}
              className="text-white bg-blue-700 mr-2 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Approve Timesheet
            </button>
          )}
          {checkapproved && !showapproveReject ? (
            <button
              type="button"
              onClick={() => openModal("Reject Timesheet")}
              className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
            >
              Reject Timesheet
            </button>
          ) : (
            userRoleType === USERROLEENUM?.ADMIN && !showapproveReject && (
              <button
                type="button"
                onClick={() => openModal("Reject Timesheet")}
                className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
              >
                Reject Timesheet
              </button>
            )
          )}
        </div>
    
    </>
  );
};

export default ApproveRejectForm;
